module.exports = __webpack_public_path__ + "img/header-bg.078ebd7.png";